module.exports = __webpack_public_path__ + "static/media/nz.0790c10e.jpg";